/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'

import { Grid } from '@material-ui/core'

import ButtonGZ from '../../components/Button'
import useStyles from './styles'

import Context from '../../context'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function HighLightsList() {
  const classes = useStyles()
  const { setUser, setAboutCurrentPage } = useContext(Context)

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }
    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: 'Tipo de Destaque',
      buttons: [
        {
          title: 'Voltar',
          pathname: '/highlightslist'
        }
      ]
    })
  }, [])

  return (
    <>
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.content}>
            <div className={classes.main}>
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Grid className={classes.inputGroup}>
                    <div className={classes.box}>
                      <h4>Escolha o tipo de destaque a ser cadastrado</h4>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
          <Link
            to={{
              pathname: '/muralform',
              state: { createTypeHighlight: 'mural' }
            }}
            style={{ textDecoration: 'none', color: '#30287b', width: '100%' }}
          >
            <ButtonGZ style={{ width: '100%' }} color="secondary">
              Mural
            </ButtonGZ>
          </Link>
          <Link
            to={{
              pathname: '/muralform',
              state: { createTypeHighlight: 'partnerList' }
            }}
            style={{ textDecoration: 'none', color: '#30287b', width: '100%' }}
          >
            <ButtonGZ style={{ width: '100%' }} color="secondary">
              Lista de Parceiros
            </ButtonGZ>
          </Link>
          <Link
            to={{
              pathname: '/muralform',
              state: { createTypeHighlight: 'directLink' }
            }}
            style={{ textDecoration: 'none', color: '#30287b', width: '100%' }}
          >
            <ButtonGZ style={{ width: '100%' }} color="secondary">
              Link direto
            </ButtonGZ>
          </Link>
        </div>
      </div>
      {/* <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.main}>
            <Grid container spacing={3}>
              <Grid item xs={8}>
                <Grid className={classes.inputGroup}>
                  <div className={classes.box}>
                    <h4>Escolha o tipo de destaque a ser cadastrado</h4>
                    <div>
                      <ButtonGZ color="secondary" onClick={hideDeleteModal}>
                        Mural
                      </ButtonGZ>
                      <ButtonGZ color="secondary" onClick={hideDeleteModal}>
                        Lista de Parceiros
                      </ButtonGZ>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default HighLightsList
